module.exports = __webpack_public_path__ + "img/logo-wto.f32e81d9.jpg";